<template>
  <div class="pcsbianliu-box">
    <title1 type="1" title="PCS变流器监控" />
	<div class="main-box">
		<div class="cell">
			<div class="top">日充电量</div>
			<div class="bottom">
				<span>{{infoObj.day_charge_elect || 0}}</span>kWh
			</div>
		</div>
		<div class="cell">
			<div class="top">有功功率</div>
			<div class="bottom">
				<span>{{infoObj.charge_power || 0}}</span>kW
			</div>
		</div>
		<div class="cell">
			<div class="top">累计充电量</div>
			<div class="bottom">
				<span>{{infoObj.charge_cur || 0}}</span>kWh
			</div>
		</div>
		<div class="cell">
			<div class="top">日放电量</div>
			<div class="bottom">
				<span>{{infoObj.day_discharge_elect || 0}}</span>kWh
			</div>
		</div>
		<div class="cell">
			<div class="top">无功功率</div>
			<div class="bottom">
				<span>{{infoObj.discharge_power || 0}}</span>kVar
			</div>
		</div>
		<div class="cell">
			<div class="top">累计放电量</div>
			<div class="bottom">
				<span>{{infoObj.discharge_cur || 0}}</span>kWh
			</div>
		</div>
		<img class="mainimg" src="@/assets/images/energyStorage/PCSjiankong.png" alt="">
		
		
		<img v-if="infoObj.pcs_status==3" class="mainimg1" src="@/assets/images/energyStorage/chongdianzhong.png" alt="">
		<img v-if="infoObj.pcs_status==0" class="mainimg1" src="@/assets/images/energyStorage/zanting.png" alt="">
		<img v-if="infoObj.pcs_status==1" class="mainimg1" src="@/assets/images/energyStorage/daiji.png" alt="">
		<img v-if="infoObj.pcs_status==2" class="mainimg1" src="@/assets/images/energyStorage/guzhang.png" alt="">
		<img v-if="infoObj.pcs_status==4" class="mainimg1" src="@/assets/images/energyStorage/fangdianzhong.png" alt="">
		<div class="name">
			{{infoObj.pcs_devno}}
		</div>
	</div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1
  },
  data() {
    return {
		infoObj: {}
	};
  },
  destroyed() {
    this.$bus.$off('bigScreen::storedEnergyId')
  },
  mounted() {
    this.$bus.$on("bigScreen::storedEnergyId", () => {
      this.getPcsbianliuqijiankong()
    })
	this.getPcsbianliuqijiankong()
  },
  methods: {
    getPcsbianliuqijiankong() {
		  let _this = this
		  let params = {
			'enCode': "chuneng-quanguo-pcsblqjk",
			'@energyId': localStorage.getItem('bigScreen::storedEnergyId') || 'ES00001'
		  }
		  dataInterface.dataFaceApi(params).then((res) => {
			if (!res || !res.length) return
				console.log(res, 'PCS变流器监控')
				this.infoObj = res[0]
		  })
		  .catch((err) => {
			console.log(err, 'error');
		  })
		
	},
  },
};
</script>

<style lang="scss" scope>
@import "@/views/components/energyStorage/comm.scss";
.pcsbianliu-box {
	.main-box{
		width: 550px;
		height: 300px;
		text-align: center;
		position: relative;
		.mainimg{
			width: 300px;
			height: 300px;
		}
		.mainimg1{
			width: 100px;
			position: absolute;
			left: 50%;
			margin-left: -50px;
			top: 180px;
		}
		.name{
			width: 200px;
			position: absolute;
			left: 50%;
			top: 96px;
			margin-left: -100px;
			font-size: 36px;
			// font-weight: 600;
			font-family: 'PMZD';
			letter-spacing:3px;
		}
		.cell{
			font-size: 24px;
			width: 180px;
			.top{
				height: 30px;
				line-height: 30px;
			}
			.bottom{
				color:#31C6C9;
				height: 30px;
				line-height: 30px;
				span{
					font-size: 32px;
					// font-weight: 600;
					font-family: "HT";
					margin-right: 10px;
				}
			}
		}
		.cell:nth-child(1) {
			position: absolute;
			left: -30px;
			top: 30px;
			text-align: right;
		}
		.cell:nth-child(2) {
			position: absolute;
			left: -80px;
			top: 125px;
			text-align: right;
		}
		.cell:nth-child(3) {
			position: absolute;
			left: -30px;
			top: 210px;
			text-align: right;
		}
		.cell:nth-child(4) {
			position: absolute;
			right: -30px;
			top: 30px;
			text-align: left;
		}
		.cell:nth-child(5) {
			position: absolute;
			right: -80px;
			top: 125px;
			text-align: left;
		}
		.cell:nth-child(6) {
			position: absolute;
			right: -35px;
			top: 210px;
			text-align: left;
		}
	}
}
</style>
